import React, { FC, PropsWithChildren } from 'react';
import { getEnv, ENV_TYPE } from '@tarojs/taro';
import { Button as NativeButton } from '@tarojs/components';
import classNames from 'classnames';
import { ButtonProps } from '@tarojs/components/types/Button';
import View from '../view';
import Loading from '../loading';

const SIZE_CLASS = {
  default: 'normal',
  mini: 'small',
};

const TYPE_CLASS = {
  primary: 'primary',
  info: 'info',
  danger: 'danger',
};

export type IButtonType = 'primary' | 'info' | 'danger' | 'default';

export interface IButtonProps extends PropsWithChildren<Omit<ButtonProps, 'type' | 'style' | 'loading' | 'disabled'>> {
  type?: IButtonType;
  disabled?: boolean;
  loading?: boolean;
  round?: boolean;
  full?: boolean;
  plain?: boolean;
}

const TARO_ENV = getEnv();

const Button: FC<IButtonProps> = ({ children, className = '', size = 'default', disabled, type = 'default', round, full, plain, loading, onClick, ...restProps }) => {
  const rootClassName = ['ink-button'];
  const classObject = {
    [`ink-button--${SIZE_CLASS[size]}`]: SIZE_CLASS[size],
    'ink-button--disabled': disabled,
    [`ink-button--${type}`]: TYPE_CLASS[type],
    'ink-button--round': round,
    'ink-button--full': full,
    'ink-button--plain': plain,
  };

  let loadingComponent: JSX.Element | null = null;
  if (loading) {
    loadingComponent = (
      <View className="ink-button__icon">
        <Loading size={size === 'mini' ? 30 : 0} />
      </View>
    );
    rootClassName.push('ink-button--icon');
  }

  const button = <NativeButton className="ink-button__button" {...restProps} onClick={!disabled ? onClick : undefined} />;

  return (
    <View
      className={classNames(rootClassName, classObject, className)}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {TARO_ENV === ENV_TYPE.WEB && !disabled && button}
      {TARO_ENV === ENV_TYPE.WEAPP && !disabled && button}
      {TARO_ENV === ENV_TYPE.ALIPAY && !disabled && button}
      {loadingComponent}
      <View className="ink-button__text">{children}</View>
    </View>
  );
};

export default Button;
